/** Lightweight module-level emitter so any component can fire a contextual tip */
type TipHandler = (text: string) => void;
let _handler: TipHandler | null = null;

export const tipEmitter = {
  on:   (h: TipHandler)  => { _handler = h; },
  off:  ()               => { _handler = null; },
  emit: (text: string)   => { _handler?.(text); },
};
